import { workspaceManager as workspace } from "../../constants/actionTypes";
import { emptyList } from "../../constants/componentConstants";

const INITIAL_STATE = {
  workspaceDashboardList: emptyList,
  workspaceListLoading: true,
  postAPISuccessFul: false,
  buttonLoading: false,
  workspaceLoading: false,
  activeWorkspace: null,
  workspaceDetails: "",
  workspaceUsersDetails: "",
  resendInvitation: "",
  deleteWorkspaceSuccess: "",
  instanceSizeLoading: false,
  instance_size_details: null,
  resourceTemplates: null,
  activeWorkspaceResource: null,
  resourceLoading: false,
  authLoading: false,
  resTempLoading: false,
  workspaceActionSuccess: "",
  workspaceResourceList: emptyList,
  publicWorkspaceResourceList: emptyList,
  publicWorkspaceListLoading: false,
  userInvitations: [],
  userInvitationLoading: false,
  linkDelinkLoading: false,
  linkDelinkSuccess: false,
  workspaceInvitation: "",
  invitationCsvData: "",
  workspaceError: "",
  generateInviteLoading: false,
  inviteLink: "",
  workspaceTenantList: "",
  workspaces: "",
  previousReportsList: "",
  reports: "",
  isInviteLinkAvailable: "NOT_LOADED",
  createWSpaceError: {},
  addResourceError: {},
  authConfigSetError: {},
  workspaceInvite: {},
  workspaceInviteError: {},
  verifiedWorkspace: {},
  verifiedWorkspaceError: {},
  workspaceForAAD: {},
  workspaceForAADError: {},
  workspaceAuthResponse: {},
  workspaceAuthError: {},
  tenantsForWorkspace: [],
  wsUser: {},
  wsEditUser: {},
  wsAddEditError: {},
  addWorkspaceResources: {
    data: {},
    loading: false,
  },
  getAllCloudVMSku: {
    data: [],
    loading: false,
    success: false
  },
  getAllCloudVMInstance: {
    data: [],
    loading: false,
    success: false
  },
};

const workspaceManager = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case workspace.SET_WORKSPACE_DASHBOARD_LIST:
      return {
        ...state,
        workspaceDashboardList: action?.data?.data,
        isInviteLinkAvailable: "NOT_LOADED",
        createWSpaceError: {},
        addResourceError: {},
        authConfigSetError: {},
      };
    case workspace.SET_WORKSPACE_DASHBOARD_LIST_ERROR:
      return {
        ...state,
        workspaceDashboardList: { emptyList },
        isInviteLinkAvailable: "NOT_LOADED",
      };
    case workspace.SET_WORKSPACE_LIST_LOADING:
      return {
        ...state,
        workspaceListLoading: action?.payload,
      };
    case workspace.CREATE_WORKSPACE_ERROR:
      return {
        ...state,
        postAPISuccessFul: false,
        createWSpaceError: action?.payload,
        addResourceError: {},
        authConfigSetError: {},
      };
    case workspace.CREATE_WORKSPACE_SUCCESS:
      return {
        ...state,
        postAPISuccessFul: true,
        activeWorkspace: { workspace_id: action?.payload?.workspace_id, ...action?.payload },
        isInviteLinkAvailable: "NOT_LOADED",
        createWSpaceError: {},
        addResourceError: {},
        authConfigSetError: {},
      };
    case workspace.EDIT_WORKSPACE_SUCCESS:
      return {
        ...state,
        postAPISuccessFul: true,
        activeWorkspace: { workspace_id: action?.payload?.id, ...action?.payload },
        isInviteLinkAvailable: "NOT_LOADED",
        createWSpaceError: {},
        addResourceError: {},
        authConfigSetError: {},
      };

    case workspace.CREATE_AUTH_CONFIG_SUCCESS:
      return {
        ...state,
        authConfigSetError: {},
      };

    case workspace.CREATE_AUTH_CONFIG_ERROR:
      return {
        ...state,
        createWSpaceError: {},
        addResourceError: {},
        authConfigSetError: action?.payload,
      };
    case workspace.BUTTON_LOADING:
      return {
        ...state,
        buttonLoading: action?.payload,
      };
    case workspace.SUCCESS_WORKSPACE_DETAILS:
      return {
        ...state,
        workspaceDetails: action?.data,
        workspaceError: "",
      };

    case workspace.SUCCESS_WORKSPACE_DETAILS_USERS:
      return {
        ...state,
        workspaceUsersDetails: action?.data,
      };

    case workspace.RESET_WORKSPACE_DETAILS_USERS:
      return {
        ...state,
        workspaceUsersDetails: "",
      };

    case workspace.DELETE_WORKSPACE_SUCCESS:
      return {
        ...state,
        deleteWorkspaceSuccess: action?.payload,
      };
    case workspace.POST_API_SUCCESSSFUL:
      return {
        ...state,
        postAPISuccessFul: action?.payload,
      };
    case workspace.SET_ACTIVE_WORKSPACE:
      const data = action?.payload;
      return {
        ...state,
        activeWorkspace: {
          ...data,
          workspace_name: data?.workspace_name,
          tenant_id: data?.tenant_id,
          tenant_name: data?.tenant_name,
          lab_type: data?.lab_type,
          is_all_day: data?.is_all_day,
          is_extra_schedule: data?.is_extra_schedule,
          schedule_type: data?.schedule_type,
          schedule_payload: {
            schedule_payload: data?.scheduler_id?.schedule_payload,
            extra_schedule_payload: data?.scheduler_id?.extra_schedule_payload,
          },
        },
      };
    case workspace.INSTANCE_SIZE_PRICING_LOADING:
      return {
        ...state,
        instanceSizeLoading: action?.payload,
      };
    case workspace.SET_INSTANCE_SIZE_PRICING:
      return {
        ...state,
        instance_size_details: action?.payload?.instance_size_details,
        extension_pack_details: action?.payload?.extension_pack_details,
        currency: action?.payload?.currency,
        pricing_id: action?.payload?.pricing_id,
        profile_type: action?.payload?.profile_type,
        profile_type_name: action?.payload?.profile_type_name,
        vm_idle_state_suspend_duration: action?.payload?.vm_idle_state_suspend_duration
      };
    case workspace.SET_RESOURCE_TEMPLATE:
      return {
        ...state,
        resourceTemplates: action?.payload,
      };
    case workspace.SET_WORKSPACE_LOADING:
      return {
        ...state,
        workspaceLoading: action?.payload,
      };
    case workspace.SET_WORKSPACE_RESOURCE:
      return {
        ...state,
        activeWorkspaceResource: { ...action?.payload, resource_id: { id: action?.payload?.id } },
      };
    case workspace.SET_RESOURCE_LOADING:
      return {
        ...state,
        resourceLoading: action?.payload,
      };
    case workspace.SET_AUTH_LOADING:
      return {
        ...state,
        authLoading: action?.payload,
      };
    case workspace.SET_RES_TEMPLATE_LOADING:
      return {
        ...state,
        resTempLoading: action?.payload,
      };
    case workspace.SET_WORKSPACE_AUTH_CONFIG:
      return {
        ...state,
        activeWorkspaceAuthConfig: action?.payload,
      };
    case workspace.SET_INVITE_LINK: {
      return {
        ...state,
        inviteLink: action?.payload?.invitation_link,
      };
    }
    case workspace.RESET_WORKSPACE_FORM:
      return {
        ...state,
        activeWorkspace: null,
        buttonLoading: false,
        instanceSizeLoading: false,
        instance_size_details: null,
        resourceTemplates: null,
        postAPISuccessFul: false,
        workspaceLoading: false,
        activeWorkspaceResource: null,
        activeWorkspaceAuthConfig: null,
        resourceLoading: false,
        authLoading: false,
        generateInviteLoading: false,
        inviteLink: "",
      };
    case workspace.WORKSPACE_ACTION_SUCCESS:
      return {
        ...state,
        workspaceActionSuccess: {
          ...action?.payload,
        },
      };
    case workspace.SET_WORKSPACE_RESOURCE_LIST:
      return {
        ...state,
        workspaceResourceList: action?.data?.data,
      };
    case workspace.SET_WORKSPACE_RESOURCE_LIST_ERROR:
      return {
        ...state,
        workspaceResourceList: { emptyList },
      };
    case workspace.SET_PUBLIC_WORKSPACE_LIST_LOADING:
      return {
        ...state,
        publicWorkspaceListLoading: action?.payload,
      };
    case workspace.SET_PUBLIC_WORKSPACE_RESOURCE_LIST:
      return {
        ...state,
        publicWorkspaceResourceList: action?.data?.data,
      };
    case workspace.SET_PUBLIC_WORKSPACE_RESOURCE_LIST_ERROR:
      return {
        ...state,
        publicWorkspaceResourceList: { emptyList },
      };
    case workspace.SET_USER_INVITATION:
      return {
        ...state,
        userInvitations: action?.payload,
      };
    case workspace.SET_USER_INVITATION_LOADING:
      return {
        ...state,
        userInvitationLoading: action?.payload,
      };
    case workspace.SET_LINK_DELINK_LOADING:
      return {
        ...state,
        linkDelinkLoading: action?.payload,
      };
    case workspace.SET_LINK_DELINK_SUCCESS:
      return {
        ...state,
        linkDelinkSuccess: action?.payload,
      };

    case workspace.SUCCESS_DELETE_WORKSPACE_USER:
      return {
        ...state,
        workspaceInvitation: action?.data,
      };

    case workspace.SUCCESS_DOWNLOAD_INVITATION:
      return {
        ...state,
        invitationCsvData: action?.data,
      };

    case workspace.SUCCESS_RESEND_INVITATION:
      return {
        ...state,
        resendInvitation: action?.data,
      };

    case workspace.SET_WEBSOCKET_WORKSPACE_RESOURCE_LIST: {
      let tempResourceList = state?.workspaceResourceList;
      tempResourceList?.results.forEach((element) => {
        if (action?.data?.payload && element?.id === action?.data?.payload?.vm) {
          element.vm_state = action?.data?.payload?.vm_state;
        }
      });
      return {
        ...state,
        workspaceResourceList: tempResourceList,
      };
    }

    case workspace.CLEAR_DOWNLOAD_INVITATION:
      return {
        ...state,
        invitationCsvData: "",
      };
    case workspace.SUCCESS_TENANT_LIST_USAGE:
      return {
        ...state,
        workspaceTenantList: action?.data,
      };
    case workspace.SUCCESS_WORKSPACES:
      return {
        ...state,
        workspaces: action?.data,
      };
    case workspace.SUCCESS_GENERATE_REPORT_LIST:
      return {
        ...state,
        previousReportsList: action?.data,
      };
    case workspace.SUCCESS_GENERATE_REPORT:
      return {
        ...state,
        reports: action?.data,
      };
    case workspace.RESET_GENERATE_REPORT:
      return {
        ...state,
        reports: "",
      };
    case workspace.ADD_RESOURCE_SUCCESS:
      return {
        ...state,
        activeWorkspaceResource: {
          ...state.activeWorkspaceResource,
          ...action?.payload,
          resource_id: {
            id: action?.payload?.resource_id,
          },
        },
        addResourceError: {},
        authConfigSetError: {},
      };
    case workspace.ADD_RESOURCE_ERROR:
      return {
        ...state,
        addResourceError: action?.payload,
        authConfigSetError: {},
      };
    case workspace.SUCCESS_WORKSPACE_ADD_USER:
      return {
        ...state,
        wsUser: action?.payload,
      };
    case workspace.CLEAR_WORKSPACE_ADD_USER:
      return {
        ...state,
        wsUser: "",
      };
    case workspace.SUCCESS_WORKSPACE_EDIT_USER:
      return {
        ...state,
        wsEditUser: action?.payload,
      };
    case workspace.ERROR_WORKSPACE_ADD_USER:
    case workspace.ERROR_WORKSPACE_EDIT_USER:
      return {
        ...state,
        wsAddEditError: action?.payload,
      };
    case workspace.GENERATE_INVITE_LOADING:
      return {
        ...state,
        generateInviteLoading: action?.payload,
      };
    case workspace.SET_INVITE_LINK_AVAILABLE:
      return { ...state, isInviteLinkAvailable: action?.data };
    case workspace.ERROR_WORKSPACE_DETAILS:
      return {
        ...state,
        workspaceError: action?.data,
        workspaceDetails: "",
      };
    case workspace.SET_WORKSPACE_AUTH_CONFIG_ERROR:
    case workspace.ERROR_DELETE_WORKSPACE_USER:
    case workspace.ERROR_WORKSPACE_DETAILS_USERS:
    case workspace.ERROR_DOWNLOAD_INVITATION:
    case workspace.ERROR_RESEND_INVITATION:
    case workspace.ERROR_TENANT_LIST_USAGE:
    case workspace.ERROR_WORKSPACES:
    case workspace.ERROR_GENERATE_REPORT_LIST:
    case workspace.ERROR_GENERATE_REPORT:
      return {
        ...state,
        workspaceError: action?.data,
      };
    case workspace.SET_INVITATION:
      return {
        ...state,
        workspaceInvite: action?.data,
      };
    case workspace.SET_INVITATION_ERROR:
      return {
        ...state,
        workspaceInviteError: action?.data,
      };
    case workspace.SET_WORKSPACE_VERIFIED:
      return {
        ...state,
        verifiedWorkspace: action?.data,
      };
    case workspace.SET_WORKSPACE_VERIFIED_ERROR:
      return {
        ...state,
        verifiedWorkspaceError: action?.data,
      };
    case workspace.AAD_USER_LOGIN_SUCCESS:
      return {
        ...state,
        workspaceForAAD: action?.data,
      };
    case workspace.AAD_USER_LOGIN_ERROR:
      return {
        ...state,
        workspaceForAADError: action?.data,
      };
    case workspace.WS_AUTH_RES_SUCCESS:
      return {
        ...state,
        workspaceAuthResponse: action?.data,
      };
    case workspace.WS_AUTH_RES_ERROR:
      return {
        ...state,
        workspaceAuthError: action?.data,
      };
    case workspace.SET_TENANT_LIST_FOR_WORKSPACE:
      return {
        ...state,
        tenantsForWorkspace: action?.data,
      };

    case workspace.ADD_WORKSPACE_RESOURCES_ACTION:
      return {
        ...state,
        addWorkspaceResources: {
          ...state?.addWorkspaceResources,
          loading: true,
        },
      };

    case workspace.ADD_WORKSPACE_RESOURCES_SUCCESS:
      return {
        ...state,
        addWorkspaceResources: {
          ...state?.addWorkspaceResources,
          data: action?.payload,
          loading: false,
        },
      };

    case workspace.ADD_WORKSPACE_RESOURCES_ERROR:
      return {
        ...state,
        addWorkspaceResources: {
          ...state?.addWorkspaceResources,
          loading: false,
        },
      };

    case workspace.ADD_WORKSPACE_RESOURCES_RESET:
      return {
        ...state,
        addWorkspaceResources: {
          ...state?.addWorkspaceResources,
          data: {}
        },
      };

    case workspace.GET_ALL_CLOUD_VM_SKU_ACTION:
      return {
        ...state,
        getAllCloudVMSku: {
          ...state?.getAllCloudVMSku,
          loading: true,
          success: false,
          data: []
        },
      };
    case workspace.GET_ALL_CLOUD_VM_SKU_SUCCESS:
      return {
        ...state,
        getAllCloudVMSku: {
          ...state?.getAllCloudVMSku,
          loading: false,
          success: true,
          data: action?.payload || []
        },
      };
    case workspace.GET_ALL_CLOUD_VM_SKU_ERROR:
      return {
        ...state,
        getAllCloudVMSku: {
          ...state?.getAllCloudVMSku,
          loading: false,
          success: false,
          data: []
        },
      };
    case workspace.GET_ALL_CLOUD_VM_SKU_RESET:
      return {
        ...state,
        getAllCloudVMSku: {
          ...state?.getAllCloudVMSku,
          loading: false,
          success: false,
          data: []
        },
      };

    case workspace.GET_ALL_CLOUD_VM_INSTANCE_ACTION:
      return {
        ...state,
        getAllCloudVMInstance: {
          ...state?.getAllCloudVMInstance,
          loading: true,
          success: false,
          data: []
        },
      };
    case workspace.GET_ALL_CLOUD_VM_INSTANCE_SUCCESS:
      return {
        ...state,
        getAllCloudVMInstance: {
          ...state?.getAllCloudVMInstance,
          loading: false,
          success: true,
          data: action?.payload || []
        },
      };
    case workspace.GET_ALL_CLOUD_VM_INSTANCE_ERROR:
      return {
        ...state,
        getAllCloudVMInstance: {
          ...state?.getAllCloudVMInstance,
          loading: false,
          success: false,
          data: []
        },
      };
    case workspace.GET_ALL_CLOUD_VM_INSTANCE_RESET:
      return {
        ...state,
        getAllCloudVMInstance: {
          ...state?.getAllCloudVMInstance,
          loading: false,
          success: false,
          data: []
        },
      };

    default:
      return state;
  }
};

export default workspaceManager;
